<template>
    <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">
                        {{ form.id ? 'Update Series Number' : 'Set New Series Number' }}
                    </h4>
                    <p>DATE: {{ date }}</p>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Start Number</label>
                        <ValidationProvider name="start" rules="required" v-slot="{ passed, failed }">
                            <fg-input type="number" :error="failed ? 'The start field is required' : null"
                                :hasSuccess="passed" name="start" v-model="form.start">
                            </fg-input>
                        </ValidationProvider>
                    </div>
                    <div class="form-group">
                        <label>End Number</label>
                        <ValidationProvider name="end" rules="required" v-slot="{ passed, failed }">
                            <fg-input type="number" :error="failed ? 'The end field is required' : null"
                                :hasSuccess="passed" name="end" v-model="form.end">
                            </fg-input>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="card-footer text-right">
                    <p-button type="info" native-type="submit">Save</p-button>
                </div>
            </div>
        </form>
    </ValidationObserver>
</template>
<script>
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { ReportSeriesNumber } from '@/resources/report_series_number'

extend("required", required);

export default {
    props: ['series_number', 'date'],
    data() {
        return {
            form: {
                start: "",
                end: "",
            },
        };
    },
    watch: {
        branch: function () {
            if (this.series_number) this.form = Object.assign({}, this.series_number)
        }
    },
    created: function () {
        if (this.series_number) this.form = Object.assign({}, this.series_number)
    },
    beforeDestroy() {
        this.form = {
            code: "",
            name: "",
        }
    },
    methods: {
        submit() {
            this.$loading = true
            let user = this.$store.state.user
            this.form.user_id = user.id
            this.form.date = this.date
            let request = this.form.id ? ReportSeriesNumber.update(this.form) : ReportSeriesNumber.create(this.form)

            request
                .then(result => {
                    this.$notify({
                        type: 'success',
                        title: "Success",
                        text: 'Series has been saved',
                    });
                    this.$emit('save', true)
                })
                .catch(error => {

                }).finally(() => {
                    this.$loading = false
                })
        }
    }
}
</script>
<style></style>
